// extracted by mini-css-extract-plugin
module.exports = {"quote":"style-module--quote--2jz8e","quote__author":"style-module--quote__author--kEsYx","quote__content":"style-module--quote__content--2RfT-"};